import { Resources } from './resources'


class AuthResource extends Resources {
  login ( credentials ) {
    return this.http.post( 'signin', credentials )
  }
  checkToken ( token ) {
    return this.http.post( 'token ', token )
  }
}

// const endPoint = process.env.NODE_ENV === 'development'
//   ? 'http://users.localhost'
//   : 'https://auth.omb11.com'

const endPoint = process.env.REACT_APP_AUTH_URL

export default new AuthResource( 'auth', endPoint )


// WEBPACK FOOTER //
// ./src/resources/auth.js